<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="1200px"
      scrollable
      @keydown="executeCloseModalItemsHes"
      @click:outside="executeCloseModalItemsHes"
    >
      <v-card v-if="currentServiceWithHes">
        <div class="p-4 pb-0">
          <h5>
            Listado de HES de Servicio de OC:
            <b>
              {{ currentServiceWithHes ? currentServiceWithHes.sap_code : "-" }}
            </b>
          </h5>
        </div>
        <hr />
        <v-card-text>
          <v-container class="pt-0">
            <section>
              <div class="mr-12">
                <h6 class="">Descripción:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes
                      ? currentServiceWithHes.description
                      : "-"
                  }}
                </p>
              </div>
            </section>
            <section class="d-flex align-items-center my-8">
              <div class="mr-12">
                <h6 class="">Código del Servicio:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes
                      ? currentServiceWithHes.material.code
                      : "-"
                  }}
                </p>
              </div>
              <div class="mr-12">
                <h6 class="">Nombre del Servicio:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes
                      ? currentServiceWithHes.material.name
                      : "-"
                  }}
                </p>
              </div>
              <div class="mr-12">
                <h6 class="">Cantidad del Servicio:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes ? currentServiceWithHes.quantity : "-"
                  }}
                </p>
              </div>
              <div class="mr-12">
                <h6 class="">Precio Neto del Servicio:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes.price
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.price)
                        )}`
                      : "Por definir"
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </div>
            </section>
            <section class="d-flex align-items-center my-8">
              <div class="mr-12">
                <h6 class="">Monto Neto:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes.total
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.total)
                        )}`
                      : "Por definir"
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </div>
              <div class="mr-12">
                <h6 class="">IVA:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes.applied_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.applied_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !currentServiceWithHes.applied_tax
                      ? ""
                      : currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </div>
              <div>
                <h6 class="">Monto Total:</h6>
                <p class="font-weight-bold">
                  {{
                    currentServiceWithHes.price_with_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(currentServiceWithHes.price_with_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !currentServiceWithHes.price_with_tax
                      ? ""
                      : currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </p>
              </div>
            </section>
            <v-icon color="purple" class="mr-1">
              mdi-alert-circle
            </v-icon>
            <b>
              HES creada directamente en SAP
            </b>
            <v-data-table
              class="px-2 elevation-4 pt-2 mt-4"
              :headers="tableHeaders"
              :items="wrappedHes"
              :items-per-page="200"
              hide-default-footer
              loading-text="Cargando HES"
              item-key="id"
              no-data-text="Sin HES asociadas"
              @page-count="pageCount = $event"
            >
              <template v-slot:item.code="{ item }">
                <div class="d-flex justify-content-start">
                  <v-chip
                    label
                    small
                    color="blue lighten-1"
                    class="mt-0 text-white"
                  >
                    {{ item.inventory_entry.sap_code }}
                  </v-chip>
                  <v-icon
                    v-if="item.created_in_sap"
                    color="purple"
                    class="ml-2"
                  >
                    mdi-alert-circle
                  </v-icon>
                </div>
              </template>
              <template v-slot:item.inventory_entry="{ item }">
                <div class="text-left">
                  {{
                    item.inventory_entry.project
                      ? item.inventory_entry.project.name
                      : item.inventory_entry.cost_center.name
                  }}
                </div>
              </template>
              <template v-slot:item.user="{ item }">
                <p class="text-left my-0">
                  {{ item.created_by }}
                </p>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span v-if="item.created_at != null">{{
                  formatDateToHuman(item.created_at)
                }}</span>
              </template>
              <template v-slot:item.amount_hes="{ item }">
                <div class="text-right">
                  {{
                    item.quantity
                      ? new Intl.NumberFormat("de-DE").format(
                          calculateNetAmountHesInList(
                            item,
                            currentServiceWithHes
                          )
                        )
                      : 0
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </div>
              </template>
              <template v-slot:item.iva="{ item }">
                <div class="text-right">
                  {{ item.quantity ? calculateIvaAmountHes(item) : "-" }}
                  {{
                    calculateIvaAmountHes(item) === "-"
                      ? ""
                      : currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </div>
              </template>
              <template v-slot:item.amount_hes_with_iva="{ item }">
                <div class="text-right">
                  {{
                    item.quantity
                      ? new Intl.NumberFormat("de-DE").format(
                          calculateTotalAmountHesInList(
                            item,
                            currentServiceWithHes
                          )
                        )
                      : 0
                  }}
                  {{
                    currentServiceWithHes.currency
                      ? currentServiceWithHes.currency
                      : "CLP"
                  }}
                </div>
              </template>
              <template v-slot:item.percentage="{ item }">
                <div class="text-right">
                  {{
                    item.quantity
                      ? Number(
                          calculatePercentageHesInList(item).toFixed(2)
                        ).toLocaleString("es-ES", {
                          style: "decimal",
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2,
                        })
                      : 0
                  }}%
                </div>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalItemsHes"
          >
            <small> Cerrar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { formatDateMomentToHuman } from "@/helpers/common";
import {
  DECIMAL_IVA_APLICABLE,
  calculateNetAmountHes,
  calculateTotalAmountHes,
} from "@/constants/supplying/hes";
import { getAllHes } from "@/constants/supplying/hes";
export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalItemsHes: {
      type: Function,
      default: () => {},
    },
    currentServiceWithHes: {
      default: null,
    },
  },
  data() {
    return {
      tableHeaders: [
        {
          text: "Código HES",
          align: "start",
          sortable: false,
          value: "code",
          width: "15%",
        },
        {
          text: "Proyecto/CECO",
          class: "text-left",
          sortable: false,
          value: "inventory_entry",
          width: "30%",
        },
        {
          text: "Usuario",
          class: "text-left",
          sortable: false,
          value: "user",
        },

        {
          text: "Fecha",
          align: "center",
          sortable: false,
          width: "10%",
          value: "created_at",
        },
        {
          text: "Monto Neto",
          align: "end",
          width: "15%",
          sortable: false,
          value: "amount_hes",
        },
        {
          text: "IVA",
          align: "end",
          width: "10%",
          sortable: false,
          value: "iva",
        },
        {
          text: "Monto Total HES",
          align: "end",
          width: "15%",
          sortable: false,
          value: "amount_hes_with_iva",
        },
        {
          text: "Porcentaje",
          align: "end",
          width: "15%",
          sortable: false,
          value: "percentage",
        },
      ],
    };
  },
  methods: {
    ...mapActions({}),
    formatDateToHuman(date) {
      return formatDateMomentToHuman(date);
    },
    executeCloseModalItemsHes($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalItemsHes($event);
      }
    },
    calculateTotalAmountHesInList(item) {
      return calculateTotalAmountHes(item, this.currentServiceWithHes);
    },
    calculatePercentageHesInList(item) {
      let appliedTax = this.currentServiceWithHes.applied_tax
        ? this.currentServiceWithHes.applied_tax
        : 0;
      let totalAmountService = this.currentServiceWithHes.total + appliedTax;
      return (
        (this.calculateTotalAmountHesInList(item) / totalAmountService) * 100
      );
    },
    calculateNetAmountHesInList(item) {
      return calculateNetAmountHes(item, this.currentServiceWithHes);
    },
    calculateIvaAmountHes(item) {
      if (
        this.currentServiceWithHes.applied_tax &&
        this.currentServiceWithHes.tax_code === "IVA"
      ) {
        let totalAmountHes = this.calculateTotalAmountHesInList(item);
        let netAmount = totalAmountHes / (1 + DECIMAL_IVA_APLICABLE);
        //Redondear los dos decimales del total del iva
        let ivaAmount = netAmount * DECIMAL_IVA_APLICABLE;
        //Tomar solo dos decimales
        ivaAmount = Number(
          ivaAmount.toFixed(
            this.currentServiceWithHes.currency == "CLP" ? 0 : 2
          )
        );

        return new Intl.NumberFormat("de-DE").format(Number(ivaAmount));
      } else {
        return "-";
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({}),
    wrappedHes() {
      return this.currentServiceWithHes
        ? getAllHes(this.currentServiceWithHes)
        : [];
    },
  },
};
</script>

<style></style>